module.exports = __webpack_public_path__ + "media/alert.81fbefbe.mp3";